import { render, staticRenderFns } from "./AssessmentsEditor.vue?vue&type=template&id=1114d938&"
import script from "./AssessmentsEditor.vue?vue&type=script&lang=js&"
export * from "./AssessmentsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports